import { icons as LucideIcons } from "lucide-react";
import { forwardRef, memo, useMemo } from "react";
import { ICONGRAPHY } from "../icongraphy.ts";

export type IconNames = keyof typeof LucideIcons;

export type GeneralIconProps = {
	name: IconNames;
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
	strokeWidth?: number;
    fill?: string;
};

export type PinkIconProps = GeneralIconProps & {
	variant?: "pink";
	level?: 500 | 100;
	theme?: "light" | "dark" | "grey" | "green" | "yellow" | "darkGrey";
};

const Icon = forwardRef<SVGSVGElement, PinkIconProps>(({
		size = "sm",
		name,
		variant,
		level = 500,
		strokeWidth,
        fill = "none",
		theme,
		...rest
	}, ref) => {
	const LucideIcon = useMemo(() => LucideIcons[name], [name]);

	let color = useMemo(() => {
		if (theme === "light") {
			return "white";
		} else if (theme === "grey") {
			return "#CCC";
		} else if (theme === "darkGrey") {
			return "#444444";
		} else if (theme === "green") {
			return "#539553";
		} else if (theme === "yellow") {
			return "#E6B800";
		}
		return "black";
	}, [theme]);

	if (!LucideIcon) {
		return null;
	}

	return (
		<LucideIcon
			ref={ref}
			size={ICONGRAPHY.size[size]}
			color={color}
            fill={fill}
			strokeWidth={strokeWidth}
			{...rest}
		/>
	);
});

export default memo(Icon);
